import React from 'react';
import { Center, Image } from '@wegroup/design-system';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router';
import ErrorBoundary from '../../app/src/components/ErrorBoundary';
import YellowHiveMarket from './pages/YellowHiveMarket';
import useAuth from '../../app/src/features/authentication/hooks/useAuth';

export const ROUTE_SRC = '/yellowhive';

const YellowHiveRouter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { distribution } = useAuth();
  const logoUrl = distribution?.logos?.logo || '';
  return (
    <ErrorBoundary>
      <Helmet>
        <title>{distribution.name}</title>
      </Helmet>
      <Switch>
        <Redirect from={ROUTE_SRC} to={`${ROUTE_SRC}/market`} exact />
        <Route
          path={`${ROUTE_SRC}/market`}
          component={YellowHiveMarket}
          exact
        />
        <Route
          path={`${ROUTE_SRC}`}
          component={() => (
            <Center h="100%">
              <Image
                cursor="pointer"
                src={`${logoUrl}`}
                alt={`${distribution.name} logo`}
                width="100%"
                maxW="xs"
                height="100%"
                objectFit="contain"
                loading="eager"
              />
            </Center>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default YellowHiveRouter;
